import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { ActivePage, ILayoutProps } from '../app-layout/AppLayout';
import { AppLayoutWaitForQueryData } from '../app/AppLayoutWaitForQueryData';
import { pageDefaultContentWidth } from './DetailPage';

export interface IListPageProps extends ILayoutProps {
  /**
   * Maximální šířka obsahu stránky, standardně neuvedená - tedy seznamy jsou na celou šířku.
   */
  contentWidth?: number;
  /**
   * Pokud je zapnuto, tak se použije výchozí šířka obsahu stránky obdobně jako má DetailPage, pomocí contentWidth lze nastavit jinou hodnotu.
   */
  defaultContentWidth?: boolean;
  /**
   * Pokud je true, tak se nepřidává padding kolem obsahu stránky. Výchozí padding je 3x šířka, tedy 21px.
   */
  noPadding?: boolean;
  /**
   * Pokud je true, tak se obsah stránky zobrazuje v scrollovatelném kontejneru, který má výšku 100% a šířku 100% - tedy zabírá celou plochu stránky.
   */
  scrollable?: boolean;
}

export type ListPageProps = IListPageProps;

export const ListPage: React.FC<ListPageProps> = ({
  children,
  className,
  queries,
  contentWrapperClassName,
  contentWidth,
  currentPage,
  defaultContentWidth,
  noPadding,
  scrollable,
}) => {
  let cls = classNames(Classes.LIST_PAGE_LAYOUT, className);
  const contentWrapperCls = classNames(
    Classes.LIST_PAGE_CONTENT_WRAPPER,
    {
      [Classes.LIST_PAGE_CONTENT_PADDING]: !noPadding,
    },
    contentWrapperClassName
  );
  return (
    <div className={cls}>
      <ActivePage currentPage={currentPage} />
      <AppLayoutWaitForQueryData queries={queries ?? []}>
        {() => (
          <div
            className={classNames(Classes.LIST_PAGE_CONTENT_SC_WRAPPER, {
              [Classes.LIST_PAGE_CONTENT_SCROLLABLE]: scrollable,
              // [Classes.LIST_PAGE_CONTENT_PADDING]: !noPadding
            })}
          >
            <div
              className={contentWrapperCls}
              style={{
                maxWidth:
                  contentWidth !== undefined
                    ? contentWidth
                    : defaultContentWidth
                      ? pageDefaultContentWidth
                      : undefined,
              }}
            >
              {typeof children === 'function' ? children() : children}
            </div>
          </div>
        )}
      </AppLayoutWaitForQueryData>
    </div>
  );
};
